module.exports = __webpack_public_path__ + "static/img/type_bg.6daa45f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/type_bg.png
// module id = 2v32
// module chunks = 2